/**
 * How much of an answer the server checked against the sources it was given.
 *
 * The values are numbers because that is what the API sends: it serializes with
 * Newtonsoft.Json and registers no string-enum converter, so every enum it returns is an
 * integer. `Grounded` is 0, so beware `grounding.state || fallback` - a fully checked answer
 * is falsy.
 */
export enum AssistantGroundingState {
  /** Every citable claim was cited, and every citation held. */
  Grounded = 0,
  /**
   * Something here is not supported by the sources: a citation that did not hold, a marker
   * naming a source that was never offered, a claim the sources cover that the answer stated
   * without one, or a claim no source offered is about.
   */
  Unverified = 1,
  /**
   * Part of this answer was not checked - the support judge timed out, failed, or replied in
   * a shape nothing could read, or a sentence carried no citation and the sources cover it by
   * too little to decide. The citations are still shown.
   */
  Unverifiable = 2,
  /** The turn had no sources, so there was nothing to ground against. */
  NotApplicable = 3
}

/** Whether the reader should be told this answer was not fully checked. */
export const needsAGroundingNotice = (state: AssistantGroundingState): boolean =>
  state === AssistantGroundingState.Unverified || state === AssistantGroundingState.Unverifiable;
